import Styles from './Item.module.scss'
import { useCollabItemContext } from '../CollabItem'
import cx from 'classnames'
import { ItemProps } from './Types'
import { FC } from 'react'

const Item: FC<React.PropsWithChildren<ItemProps>> = ({ children, editing, className }) => {
  const { isHighlighted } = useCollabItemContext()

  return (
    <div
      className={cx(Styles.root, className, {
        [Styles.editing]: editing,
        [Styles.highlighted]: isHighlighted,
      })}
    >
      {children}
    </div>
  )
}

export { Item }
